import React from 'react';


import mapImg from '../../assets/images/contact/1.jpg'

const Map = (props) => {
    return (
        <div class="react-contacts pt-106"> 
            <div class="react-image-maping">
                {/* <img src={mapImg} alt="Map" /> */}
                <iframe style={{width:"100%"}} className='w-full' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3508.969290693778!2d77.03770727535034!3d28.420183475781467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d229c4a61db17%3A0x877fd1e1cd668cac!2sSpazedge!5e0!3m2!1sen!2sin!4v1747829289873!5m2!1sen!2sin" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                {/* <div class="react-ripple react-tooltip1"><div class="box"><span>New York</span></div></div> */}
            </div>
        </div> 
    );

}

export default Map;